import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=2c1d44a5&scoped=true&"
import script from "./SuperTable.vue?vue&type=script&lang=js&"
export * from "./SuperTable.vue?vue&type=script&lang=js&"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=2c1d44a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d44a5",
  null
  
)

export default component.exports